import { NEWS_LETTER_BLOCK_ID, GALLARY_EXPLORE_BLOCK_ID, CONTACT_US_BLOCK_ID, SOCIAL_MEDIA_BLOCK_ID, CONTACT_US, SUPPORT, SITE_MAP, PRIVACY_POLICY, TERMS_CONDITION, TERMS_OF_USE } from "../../common/constant";
import React, { Suspense, lazy } from 'react';
import { COMPANY_NAME_FULL } from '../../common/';
import FleckringFooter from './fleckring-footer';
import PageContext from '../../context';
import { history } from "../../jwt/_helpers";
import { Common } from "../../common/common";
import moment from "moment";
import { Link } from "react-router-dom";

const ImageLoader = lazy(() => import('../../common/image-loader'));


class FooterSection extends React.Component {
    static contextType = PageContext;
    constructor(props) {
        super(props);
        this.state = {
            conactDetails: null,
            newsLetterSettings: null,
            settings: [],
            gallaryBlock: null,
            gallarySetting: null,
            contactUsBlock: null,
            socialMediaBlock: null,
            socialMediaIcon: null,
            year: moment().format('YYYY')
        };
    }

    componentDidMount() {
        const context = this.context;

        const nwsData = context.blockDetails.filter((details) => details.blockId === NEWS_LETTER_BLOCK_ID);
        const gallaryExplore = context.blockDetails.filter((details) => details.blockId === GALLARY_EXPLORE_BLOCK_ID);
        const contactBlock = context.blockDetails.filter((details) => details.blockId === CONTACT_US_BLOCK_ID);
        const socialMediaBlock = context.blockDetails.filter((details) => details.blockId === SOCIAL_MEDIA_BLOCK_ID);

        this.setState({
            conactDetails: context.conactDetails ?? null,
            newsLetterSettings: nwsData[0],
            settings: nwsData[0].settings[0],
            gallaryBlock: gallaryExplore[0],
            gallarySetting: gallaryExplore[0].settings,
            contactUsBlock: contactBlock[0],
            socialMediaBlock: socialMediaBlock[0],
            socialMediaIcon: context.socialMediaIcon
        })
    }

    render() {
        return (
            <>
                {
                    this.state.newsLetterSettings && this.state.conactDetails && this.state.gallaryBlock && this.state.gallarySetting && this.state.socialMediaIcon ?
                        <div id="CONTACT" className="sec-footer">
                            <div className="container">
                                {this.state.newsLetterSettings.isEnabled ?
                                    <div className="row c-subscribe-apps">
                                        <div className="col-12 col-md-6 c-subscribe">
                                            <h2 className="title">{this.state.newsLetterSettings.blockTitle}</h2>
                                            <p className="info">{this.state.newsLetterSettings.blockSubTitle}</p>
                                            {this.state.settings.isVisible && this.state.settings.settingId === 17 ?
                                                <button className="btn btn-dark subscribe" onClick={() => { Common.navigateToLink(this.state.settings.settingValue) }} title="To Our Latest Programmes And News">{"Subscribe"}</button>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                                {this.state.gallaryBlock.isEnabled ?
                                    <div className={"c-apps " + (this.state.newsLetterSettings.isEnabled ? 'col-12 col-md-6' : 'as-row')}>
                                        <h2 className="title">{this.state.gallaryBlock.blockTitle}</h2>
                                        {this.state.gallaryBlock.blockSubTitle ?
                                            <p className="info">{this.state.gallaryBlock.blockSubTitle}</p>
                                            :
                                            null
                                        }

                                        <div className="c-btns">
                                            {this.state.gallarySetting.map((gallary, index) => {
                                                return (
                                                    gallary.isVisible ?
                                                        <a href={gallary.settingValue} target="_blank" title={''} className="btn app-store" key={index}>
                                                            <Suspense fallback={null}>
                                                                <ImageLoader src={"/images/" + gallary.settingName + ".png"} type="image"></ImageLoader>
                                                            </Suspense>
                                                        </a> : ""
                                                )
                                            })
                                            }
                                        </div>


                                        {/* <div className="c-btns">
                                            <a href="https://appsto.re/sg/VaJ76.i" target="_blank" title="Download iPhone Application From App Store" className="btn app-store">
                                                <ImageLoader src={imgAppStore} type="image"></ImageLoader>
                                            </a>
                                            <a href="https://play.google.com/store/apps/details?id=com.nationalgallerysingapore.galleryexplorer&hl=en" target="_blank" title="Download Android Application From Google Play" className="btn  google-play">
                                                <ImageLoader src={imgGooglePlay} type="image"></ImageLoader>
                                            </a>
                                        </div> */}
                                    </div>
                                    : null
                                }

                                {this.state.socialMediaBlock.isEnabled ?
                                    <div className="row c-contact-social">
                                        <div className="col-12 col-md-9 c-contact">
                                            {this.state.conactDetails.contactNumber ?
                                                <a href={"tel:" + (this.state.conactDetails.contactNumber)} target="_blank" title="Phone Number">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/tel.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactNumber}</span>
                                                </a> : null
                                            }
                                            {this.state.conactDetails.contactEmail ?
                                                <a href={"mailto:" + (this.state.conactDetails.contactEmail)} target="_blank" title="Email Address">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/email.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactEmail}</span>
                                                </a> : null
                                            }
                                            {this.state.conactDetails.contactAddress ?
                                                <a href={"https://maps.google.com/maps?q=" + (encodeURIComponent(this.state.conactDetails.contactAddress))} target="_blank" title="Address">
                                                    <Suspense fallback={null}>
                                                        <ImageLoader type="image" src="/images/contact/address.svg"></ImageLoader>
                                                    </Suspense>
                                                    <span>{this.state.conactDetails.contactAddress}</span>
                                                </a> : null
                                            }
                                        </div>
                                        <div className="col-12 col-md-3 c-social">
                                            {
                                                this.state.socialMediaIcon.map((social, index) => {
                                                    return (
                                                        <a href={social.socialMediaIconUrl} target="_blank" title={social.socialMediaIconName} key={index}>
                                                            <Suspense fallback={null}>
                                                                <ImageLoader type="image" src={"/images/social/" + social.socialMediaIconName.replace(' ', '').toLowerCase() + ".png"}></ImageLoader>
                                                            </Suspense>
                                                        </a>
                                                    )
                                                })
                                            }
                                        </div>

                                        {/* <div className="col-12 col-md-3 c-social">
                                        <a href="https://www.facebook.com/nationalgallerysg" target="_blank" title="Facebook"><ImageLoader type="image" src={imgFacebook}></ImageLoader></a>
                                        <a href="https://instagram.com/nationalgallerysingapore/" target="_blank" title="Instagram"><ImageLoader type="image" src={imgInstagram}></ImageLoader></a>
                                        <a href="https://twitter.com/natgallerysg" target="_blank" title="Twitter"><ImageLoader type="image" src={imgTwitter}></ImageLoader></a>
                                        <a href="https://www.youtube.com/user/nationalgallerysg" target="_blank" title="Youtube"><ImageLoader type="image" src={imgYoutube}></ImageLoader></a>
                                        <a href="https://www.tripadvisor.com.sg/Attraction_Review-g294265-d8077179-Reviews-National_Gallery_Singapore-Singapore.html" target="_blank" title="Tripadvisor"><ImageLoader type="image" src={imgTripadvisor}></ImageLoader></a>
                                    </div> */}
                                    </div>
                                    : null
                                }
                                {this.state.contactUsBlock.isEnabled ?
                                    <div className="row c-sitemap-copyright">
                                        <div className="col-sm-9 col-md-9 c-logo-sitemap">
                                            <a href="/" className="c-logo" title={COMPANY_NAME_FULL}>
                                                <Suspense fallback={null}>
                                                    <ImageLoader src={'/symbol-big.png'} type="image"></ImageLoader>
                                                </Suspense>
                                            </a>
                                            <div className="c-links">
                                                <Link to={'/all/mosques'} rel="noreferrer">Mosque Listing</Link>
                                                <Link to={'/all/mosques'} rel="noreferrer">Donate</Link>
                                                <Link to={'/all/donors-wall'} rel="noreferrer">Our Donors</Link>          
                                                <a href={'#'} rel="noreferrer">My Subscriptions</a> {/* https://www.ourmasjid.sg/subscriptions/ */}
                                                <a href={'https://ourmosques.commonspaces.sg/'} target="_blank" rel="noreferrer"> Book a Prayer Slot</a>
                                                {/* <a href={TERMS_CONDITION} target="_blank" rel="noreferrer">Terms &amp; Conditions</a> */}
                                            </div>
                                        </div>
                                        <div className="col-sm-3 col-md-3 c-copyright">
                                            <span>Copyright © {this.state.year} OurMasjid.SG. All Rights Reserved</span>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                        :
                        <FleckringFooter></FleckringFooter>
                }
            </>
        )
    }
}

export default FooterSection;